import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
  FormControl,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { EstatusAuditoriaEnum } from "src/app/utilerias/enums/estatusAuditoriaEnum";
import { ProyectosService } from "../../proyectos.service";
import { Msg } from "src/app/utilerias/mensajes/Msg";
import { Riesgos } from "src/app/shared/model/gestion-proyectos/riesgos/riesgo.model";
import { UrlConstantes } from "src/app/utilerias/constantes/urlconstantes";
import { Area } from "src/app/shared/model/tickets/area.model";
import { TicketsService } from "src/app/tickets/tickets.service";
import { FaseDeteccion } from "src/app/shared/model/gestion-proyectos/riesgos/fase-deteccion.model";
import { TipoRiesgo } from "src/app/shared/model/gestion-proyectos/riesgos/tipo-riesgo.model";
import { Probabilidad } from "src/app/shared/model/gestion-proyectos/riesgos/probabilidad.model";
import { SeveridadRiesgo } from "src/app/shared/model/gestion-proyectos/riesgos/severidad-riesgo.model";
import { EstrategiaSeguir } from "src/app/shared/model/gestion-proyectos/riesgos/estrategia-aseguir.model";
import { Periodicidad } from "src/app/shared/model/gestion-proyectos/riesgos/periodicidad.model";
import { HistorialDeCambiosComponent } from "../../admin-proyectos/historial-de-cambios/historial-de-cambios.component";
import { Impacto } from "src/app/shared/model/gestion-proyectos/riesgos/impacto.model";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatNativeDateModule } from "@angular/material/core";

const impactoCtrl = "impactoCtrl";
const probabilidadCtrl = "probabilidadCtrl";
const severidadCtrl = "severidadCtrl";

@Component({
  selector: "app-agregar-riesgo",
  standalone: true,
  templateUrl: "./modal-agregar-riesgo.component.html",
  styleUrls: ["./modal-agregar-riesgo.component.css"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormFieldModule,
    MatIconModule,
    MatDatepickerModule,
    MatInputModule,
    MatSelectModule,
    MatNativeDateModule,
  ],
})
export class ModalAgregarRiesgo implements OnInit {
  formRiesgo: FormGroup;
  estatus = Object.keys(EstatusAuditoriaEnum).map((estatus) => ({
    estatus,
    value: EstatusAuditoriaEnum[estatus],
  }));
  riesgo: Riesgos = new Riesgos();
  area: Area[] = [];
  faseDeteccion: FaseDeteccion[] = [];
  tipoRiesgo: TipoRiesgo[] = [];
  probabilidad: Probabilidad[] = [];
  severidad: SeveridadRiesgo[] = [];
  estrategia: EstrategiaSeguir[] = [];
  periodicidad: Periodicidad[] = [];
  impacto: Impacto[] = [];
  probabilidadXImpacto: number;
  colorSeveridad: String;
  nombreSeveridad: string;

  constructor(
    public dialogRef: MatDialogRef<ModalAgregarRiesgo>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: ProyectosService,
    private msg: Msg,
    private formBuilder: FormBuilder,
    private detectCambios: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.inicializarFormulario();
    if (this.data.riesgo == null) {
      this.riesgo = new Riesgos();
      this.riesgo.id_proyecto = this.data.id;
    } else {
      this.riesgo = this.data.riesgo;
      this.colorSeveridad = this.riesgo.severidad.color;
      this.nombreSeveridad = this.riesgo.severidad.descripcion;
    }

    this.obtenerfaseDeteccion();
    this.obtenertipoRiesgo();
    this.obtenerProbabilidad();
    this.obtenerSeveridad();
    this.obtenerEstrategia();
    this.obtenerPeriodicidad();
    this.obtenerImpactos();
  }

  onClose() {
    this.dialogRef.close();
  }

  inicializarFormulario() {
    this.formRiesgo = this.formBuilder.group({
      faseDeteccionCtrl: ["", Validators.required],
      descripcionCtrl: ["", Validators.required],
      causaRaizCtrl: ["", Validators.required],
      probabilidadCtrl: ["", Validators.required],
      severidadCtrl: ["", Validators.required],
      estrategiaCtrl: ["", Validators.required],
      periodicidadCtrl: ["", Validators.required],
      accionesSeguirCtrl: ["", Validators.required],
      responsableRecursoCtrl: ["", Validators.required],
      fechaCtrl: ["", Validators.required],
      impactoCtrl: ["", Validators.required],
    });
    this.formRiesgo.get(severidadCtrl).disable();
    this.formRiesgo.get(probabilidadCtrl).valueChanges.subscribe((valor) => {
      console.log("La respuesta es", valor);
      if (valor) {
        this.formRiesgo.get(impactoCtrl).enable();
      } else {
        this.formRiesgo.get(impactoCtrl).disable();
      }
    });
  }

  obtenerfaseDeteccion() {
    this.service
      .consultaGeneral(UrlConstantes.consultaFaseDeteccion)
      .subscribe((res) => {
        if (res != null) {
          this.faseDeteccion = res.list;
        }
      });
  }
  obtenertipoRiesgo() {
    this.service
      .consultaGeneral(UrlConstantes.consultaTipoRiesgo)
      .subscribe((res) => {
        if (res != null) {
          this.tipoRiesgo = res.list;
        }
      });
  }
  obtenerProbabilidad() {
    this.service
      .consultaGeneral(UrlConstantes.consultaProbabilidad)
      .subscribe((res) => {
        if (res != null) {
          console.log("la probabolñdaes son", res.list);
          this.probabilidad = res.list;
        }
      });
  }
  obtenerSeveridad() {
    this.service
      .consultaGeneral(UrlConstantes.consultaSeveridad)
      .subscribe((res) => {
        if (res != null) {
          this.severidad = res.list;
        }
      });
  }
  obtenerEstrategia() {
    this.service
      .consultaGeneral(UrlConstantes.consultaEstrategia)
      .subscribe((res) => {
        if (res != null) {
          this.estrategia = res.list;
        }
      });
  }
  obtenerPeriodicidad() {
    this.service
      .consultaGeneral(UrlConstantes.consultaPeriodicidad)
      .subscribe((res) => {
        if (res != null) {
          this.periodicidad = res.list;
        }
      });
  }
  obtenerImpactos() {
    this.service
      .consultaGeneral(UrlConstantes.consultaImpactos)
      .subscribe((res) => {
        if (res != null) {
          this.impacto = res.list;
        }
      });
  }

  calcularProbabilidadImpacto() {
    console.log("el impacto es ñsdfnklsdfsdjkl");
    const impacto = this.impacto.find(
      (opcion) => opcion.id_impacto == this.riesgo.id_impacto
    );
    const probabilidad = this.probabilidad.find(
      (opcion) => opcion.id_probabilidad == this.riesgo.id_probabilidad
    );

    if (impacto && probabilidad) {
      const impactoValor = impacto.valor;
      const probabilidadValor = probabilidad.valor;
      this.probabilidadXImpacto = probabilidadValor * impactoValor;
      this.riesgo.calculo_severidad = this.probabilidadXImpacto;
      for (let i = 0; i < this.severidad.length; i++) {
        if (
          this.probabilidadXImpacto >= this.severidad[i].rango_inicial &&
          this.probabilidadXImpacto <= this.severidad[i].rango_final
        ) {
          this.riesgo.id_severidad = this.severidad[i].id_severidad;
          this.colorSeveridad = this.severidad[i].color;
          this.nombreSeveridad = this.severidad[i].descripcion;
          this.formRiesgo
            .get(severidadCtrl)
            .setValue(this.severidad[i].descripcion);
        }
      }
      this.detectCambios.detectChanges();
    }
  }

  guardaActualizaRiesgo() {
    this.service.guardaRiesgo(this.riesgo).subscribe((res) => {
      this.registroHistorialDCambios(this.riesgo.id);
      if (res.pCodRetorno == "EXITO") {
        this.msg.successCall("Riesgo registrado con éxito", null, (res) =>
          this.dialogRef.close()
        );
      } else {
        this.msg.errorCall("Ocurrió un error", null, null);
      }
    });
  }

  registroHistorialDCambios(idTipo: number): void {
    let dialogRef = this.dialog.open(HistorialDeCambiosComponent, {
      disableClose: true,
      autoFocus: true,
      maxHeight: "900px",
      width: "1000px",
      panelClass: "custom-modalbox",
      data: { tipo_cambio: "RIESGO", id: idTipo },
    });
  }
}
